import { render, staticRenderFns } from "./AddictiveStuffClientHabitsEdit.vue?vue&type=template&id=4ae4bc14&scoped=true&"
import script from "./AddictiveStuffClientHabitsEdit.vue?vue&type=script&lang=js&"
export * from "./AddictiveStuffClientHabitsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae4bc14",
  null
  
)

export default component.exports